import { IAppState } from '../common/state';

export const selectIsUserAgent = (state: IAppState) => {
  const { user } = state;

  // oxlint-disable-next-line typescript/no-explicit-any
  return !user.isAuthenticated ? false : user.isAgent && !(user as any).isBuilder;
};
